import {Button, IconButton, styled, Typography} from "@mui/material";
import {useTheme} from "@mui/system";
import BackIcon from "assets/icons/BackIcon";

import SaveIcon from "assets/icons/invoice/SaveIcon";
import invoicePatternNavigationItems from "assets/js/invoicePatternNavigationItems";
import {Dispatch, SetStateAction, useRef, useState} from "react";
import shortid from "shortid";
import FactorBaseSetting from "./FactorBaseSetting";
import FactorDetailsSetting from "./FactorDetailsSetting";
import FactorTableSetting from "./FactorTableSetting";
// import FactorSettingInfoList from "./FactorSettingInfoList";

const SettingContainer = styled("div")(({theme}) => ({
    // height: 'fit-content',

    display: "flex",
    flexDirection: "column",
    // backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    gridTemplateRows: "10% 80% 10%",
}));
const TitleSection = styled(Typography)(({theme}) => ({
    height: "55px",
    // height: '100%',
    display: "flex",
    alignItems: "center",
    padding: "0 24px 0 24px",
}));
const MiddleSection = styled(Typography)(({theme}) => ({
    // height: '460px',
    minHeight: "400px",
    // maxHeight: '10000px',

    // padding: '40px',
    margin: "0 24px",
    borderRadius: theme.shape.borderRadius,
    borderWidth: "1px",
    borderColor: "#cacaca",
    borderStyle: "solid",
}));
const ActionSection = styled(Typography)(({theme}) => ({
    display: "flex",
    padding: "24px",
    height: "70px",
    flexDirection: "column",
    justifyContent: "space-evenly",
}));
const ActionButton = styled(Button)(({theme}) => ({
    height: "44px",
    fontSize: "16px",
}));
const MiddleTitleSection = styled("div")(({theme}) => ({
    padding: "16px",
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));
const NavigationContainer = styled("div")(({theme}) => ({
    padding: "12px",
    height: "40px",
    position: "relative",
    borderRadius: "4px",
    backgroundColor: "#F3F4F5",
    alignItems: "center",
    margin: "24px 16px 0 16px",
    display: "flex",
    justifyContent: "space-between",
}));
const NavigationItem = styled("div")(({theme}) => ({
    display: "flex",
    height: "30px",
    width: "80px",
    alignItems: "center",
    cursor: "pointer",
    justifyContent: "space-evenly",
    zIndex: 2,
}));
const Thumb = styled("div")(({theme, rightPosition}: { theme?: ThemeObjType; rightPosition?: number }) => ({
    position: "absolute",
    right: rightPosition || 0,
    backgroundColor: "white",
    top: "3px",
    borderRadius: "4px",
    zIndex: 1,
    height: "34px",
    width: "80px",
    transition: "all 0.3s",
}));

// @ts-ignore
const getRightPosition = (items, container, activeIndex: number) => {
    try {
        const itemRight = items.current[activeIndex]?.getBoundingClientRect().right;
        // @ts-ignore
        const containerRight = container.current?.getBoundingClientRect().right;

        // @ts-ignore
        return parseInt(containerRight - itemRight);
    } catch {
        return 0;
    }
};

const Navigation = ({setPattern}: { setPattern: Dispatch<SetStateAction<factorPatternType>> }) => {
    const itemsRef = useRef<HTMLDivElement[]>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <NavigationContainer ref={containerRef}>
            <Thumb rightPosition={getRightPosition(itemsRef, containerRef, activeTab)}/>
            {invoicePatternNavigationItems.map((item, key) => {
                const Icon = item.Icon;
                return (
                    <NavigationItem
                        // @ts-ignore
                        ref={(el) => el !== null && itemsRef.current !== null && (itemsRef.current[key] = el)}
                        key={shortid.generate()}
                        onClick={() => {
                            setActiveTab(key);
                            setPattern(item.state);
                        }}
                    >
                        <Icon active={activeTab === key}/>
                        <Typography color={activeTab === key ? "primary" : theme.palette.text.disabled} fontSize={12}>
                            {item.title}
                        </Typography>
                    </NavigationItem>
                );
            })}
        </NavigationContainer>
    );
};

export type factorPatternType = "baseSetting" | "detailsSetting" | "tableSetting";

const FactorSettingPattern = ({
                                  invoiceRef,
                                  setPattern,
                                  setFactorSetting,
                              }: {
    invoiceRef: any;
    setPattern: Dispatch<SetStateAction<number>>;
    setFactorSetting: Dispatch<SetStateAction<factorSettingType>>;
}) => {
    const theme = useTheme();

    const [factorPatternComponent, setFactorPatternComponent] = useState<factorPatternType>("baseSetting");

    return (
        <>
            <SettingContainer>
                <TitleSection variant="body1">تنظیمات چاپ</TitleSection>
                <MiddleSection>
                    <MiddleTitleSection>
                        <Typography color={theme.palette.disabled.main} variant="body2">
                            ویرایش قالب
                        </Typography>
                        <IconButton
                            onClick={() => setFactorSetting("chooseInfo")}
                            disableRipple
                            sx={{width: "25px", height: "25px"}}
                        >
                            <BackIcon/>
                        </IconButton>
                    </MiddleTitleSection>
                    <Navigation setPattern={setFactorPatternComponent}/>
                    {factorPatternComponent === "baseSetting" && <FactorBaseSetting/>}
                    {factorPatternComponent === "detailsSetting" && <FactorDetailsSetting/>}
                    {factorPatternComponent === "tableSetting" && <FactorTableSetting/>}
                    {/* <ButtonContainer>
            <UploadLogoButton />
          </ButtonContainer>
          <ListContainer>
            <FactorSettingPatternList />
          </ListContainer> */}
                </MiddleSection>
                <ActionSection>
                    <ActionButton startIcon={<SaveIcon/>} fullWidth type="submit" variant="outlined">
                        &nbsp;&nbsp;ذخیره قالب
                    </ActionButton>
                </ActionSection>
            </SettingContainer>
        </>
    );
};

export default FactorSettingPattern;
